import { Directive, ElementRef, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { StaticData } from '../helpers/static-data';

@Directive({
  selector: '[appVisibilityControl]'
})
export class VisibilityControlDirective implements OnInit, OnChanges {
  @Input() appVisibilityControl: boolean = true;

  constructor(private el: ElementRef) {}

  ngOnInit() {
    this.updateVisibility();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.appVisibilityControl) {
      this.updateVisibility();
    }
  }

  private updateVisibility() {
    // Se oculta si LogosBestDoc es false O si appVisibilityControl es false
    const shouldBeVisible = this.appVisibilityControl && StaticData.LogosBestDoc;
    this.el.nativeElement.style.visibility = shouldBeVisible ? 'visible' : 'hidden';
  }
}
